<div fxLayout="column" fxLayoutGap="10px">
	<rpshared-phone-number
		[formControl]="control"
		rpsharedRemoveHost
	></rpshared-phone-number>
	<div mat-dialog-actions>
		<button mat-button mat-dialog-close color="warn">
			Cancel
		</button>
		<button
			mat-button
			[disabled]="group.invalid || getPhoneControlInvalid"
			color="primary"
			[mat-dialog-close]="group"
		>
			Save
		</button>
	</div>
</div>
